import React from 'react';

import tlplaceholder from './img/placeholder.png';
import roundImagesEnum from './_roundImagesEnum';
import ExcerciseBlock from './ExcerciseBlock';

const titlesByRoundNumber = {
	warmups: 'warm up',
	cooldowns: 'cool down',
};

function RoundTitle({imgsrc, textBeforeImg, textAfterImg}) {
	return (
		<div className='roundTitleInnerWrapper withLine'>
			<span>{textBeforeImg}</span>
			<div className='roundTitleImage'>
				<img src={imgsrc ? imgsrc : tlplaceholder}></img>
			</div>
			<span>{textAfterImg}</span>
		</div>
	);
}

function Round({round, roundNumber, t, onItemPress, textAfterImg}) {
	return (
		<div className='roundWrapper'>
			<RoundTitle
				imgsrc={roundImagesEnum[roundNumber]}
				textAfterImg={textAfterImg}
				textBeforeImg={titlesByRoundNumber[roundNumber] || `${t('workout:round')}` }
			/>
			<div className='roundExcercisesWrapper'>
				{round.map(
					({
						excercise_info: {
							name,
							duration,
							reps,
							video_image,
							video,
							_id,
						},
						_id: hauptId,
					}) => (
						<ExcerciseBlock
							key={_id}
							t={t}
							reps={reps}
							duration={duration}
							image={video_image}
							video={video}
							name={name}
							onPress={() => {
								onItemPress(hauptId);
							}}
						/>
					)
				)}
			</div>
		</div>
	);
}

export default Round;



// WEBPACK FOOTER //
// ./src/workoutPreview/Round.js